export const toolbarConstants = {
  BACK: 'BACK',
  CREATE: 'CREATE',
  OPEN: 'OPEN',
  PRINT: 'PRINT',
  SAVE: 'SAVE',
  SEND: 'SEND',
  EDIT: 'EDIT',
  UNDO: 'UNDO',
  REDO: 'REDO',
  CUT: 'CUT',
  COPY: 'COPY',
  PASTE: 'PASTE',
  DELETE: 'DELETE',
  DOWNLOAD: 'DOWNLOAD',
  EXPORT: 'EXPORT',
  PIN: 'PIN',
  BOOKMARK: 'BOOKMARK',
  FILTER: 'FILTER',
  SETTINGS: 'SETTINGS',
  HELP: 'HELP',
  CANCEL: 'CANCEL',
  REFRESH: 'REFRESH',
  SYNC: 'SYNC',
  EXIT_TO_APP: 'EXIT_TO_APP',
  CHECK_STATUS: 'CHECK_STATUS',
  SHOW_ERA: 'SHOW_ERA',
  SYNC_CLAIM: 'SYNC',
  EFAX: 'EFAX',
};
